import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_379: DocMigration = {
  maxSchemaVersion: "0.0.379",
  description: "Add missing styleOverrides to view templates",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      if (viewTemplate.styleOverrides === undefined) {
        viewTemplate.styleOverrides = {};
      }
    }
    return json;
  },
};

export default migration_0_0_379;
